module.exports = __webpack_public_path__ + "static/media/user-regular.c3931a91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-regular.svg
// module id = 246
// module chunks = 0